
<mat-toolbar color='primary'>
    <mat-toolbar-row>
        <button mat-icon-button>
            <img src="assets/yxzx_four_logo.png" alt="" class="width31">
            <img src="assets/cpxz_ic_fyzs.png" alt="" class="width50">
        </button>     
        <div class="fyzsSize">
            <span>自由呼吸-风云影像中心</span>
        </div>   
         <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
            <ul fxLayout="row" fxLayoutGap="20px">
                <!-- <li mat-list-item routerLinkActive="list-item-active" routerLink="/notice">
                    <button mat-icon-button class="btnRelative">
                        <b>3</b>
                        <img src="assets/home_ic_tz.png" alt="" class="width30">
                        <span>通知</span>
                    </button>
                </li> -->
                <!-- <li mat-list-item routerLinkActive="list-item-active" routerLink="/password">
                    <button mat-icon-button>
                        <img src="assets/home_ic_wjmm.png" alt="" class="width30">
                        <span>修改密码</span>
                    </button>
                </li> -->
                <li>
                    <button mat-icon-button (click)="logout()">
                        <img src="assets/home_ic_tc.png" alt="" class="width30">
                        <span>退出</span>
                    </button>
                </li>
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>